<template>
  <div class="h-level">
    <div class="field h-switch">
      <b-switch v-model="hardCodedPublic" disabled type="is-primary"
        ><div class="children-overlap">
          <span>{{ hardCodedPublic ? "Public" : "Private" }}</span>
          <span class="hidden">Private</span>
        </div>
      </b-switch>
    </div>
    <cancel />
    <save v-if="canEdit" v-bind="$attrs" :saving="saving" />
  </div>
</template>

<script>
import Cancel from "@/components/spaces/Modal.Cancel";
import Save from "@/components/spaces/Modal.Save";
import { bus } from "@/components/spaces/bus.js";
import { PATCH } from "@/assets/permissions/actions.type.js";
import * as types from "@/assets/permissions/resources.type.js";

export default {
  components: { Cancel, Save },
  data() {
    return {
      saving: false,
      hardCodedPublic: true,
      canEdit: false,
    };
  },
  mounted() {
    const { $can, $attrs } = this;
    this.canEdit =
      $can(PATCH, types[$attrs.type.toUpperCase()]) || $can(PATCH, $attrs.id);

    bus.$on("saving-event", () => {
      this.saving = true;
    });
    bus.$on("saving-complete", () => {
      this.saving = false;
      this.$attrs.reset();
    });
  },
  beforeDestroy() {
    bus.$off();
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/HLevel.scss";

.h-switch span.check {
  position: relative;
  top: 0.09rem;
}

.switch-text {
  font-size: $size-small;
  font-weight: 500 !important;
}
</style>
